import { JsonLd, faqSchema } from '../lib/seo';

/** Visible FAQ block + matching FAQPage JSON-LD. Drop into any public page. */
export default function PublicFaq({ id, heading = 'Frequently asked questions', intro, faqs }) {
  if (!faqs || !faqs.length) return null;
  return (
    <section className="bg-white border-t border-[#E5E7EB]" data-testid={`faq-${id}`}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <JsonLd id={`${id}-faq`} data={faqSchema(faqs)} />
        <h2 className="font-heading text-2xl font-bold text-gray-900">{heading}</h2>
        {intro && <p className="text-gray-600 mt-3 leading-relaxed">{intro}</p>}
        <div className="mt-6 space-y-6">
          {faqs.map((f, i) => (
            <div key={i}>
              <h3 className="font-semibold text-gray-900">{f.q}</h3>
              <p className="text-gray-600 mt-2 leading-relaxed">{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
